import { faThumbsDown, faThumbsUp } from '@fortawesome/pro-regular-svg-icons';
import {
  faThumbsDown as faThumbsDownSolid,
  faThumbsUp as faThumbsUpSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { CopyButton, Icon } from '@hl/ui-components';
import { FC, ReactNode, useMemo } from 'react';

import { MessageStatus } from '../Message/types/messages';
import { MessageReactionsWrapper } from './MessageReactions.styled';

export enum ReactionType {
  upVote = 'upVote',
  downVote = 'downVote',
  copy = 'copy',
}

export const MessageReactions: FC<{
  onUpVote: () => void;
  onDownVote: () => void;
  onNeutral: () => void;
  onCopy: () => void;
  textToCopy: string;
  status: MessageStatus;
  additionalActions?: ReactNode | ReactNode[];
}> = ({
  onUpVote,
  onDownVote,
  onNeutral,
  onCopy,
  additionalActions,
  textToCopy,
  status,
}) => {
  const thumbsUpIcon = useMemo(() => {
    const liked = status;
    return (
      <div className={liked ? 'active message-reaction' : 'message-reaction'}>
        <Icon
          icon={liked ? faThumbsUpSolid : faThumbsUp}
          onClick={liked ? onNeutral : onUpVote}
          title={'Helpful'}
        />
      </div>
    );
  }, [status, onNeutral, onUpVote]);

  const thumbsDownIcon = useMemo(() => {
    const disliked = status !== null && !status;
    return (
      <div
        className={disliked ? 'active message-reaction' : 'message-reaction'}
      >
        <Icon
          icon={disliked ? faThumbsDownSolid : faThumbsDown}
          onClick={disliked ? onNeutral : onDownVote}
          title={'Not helpful'}
        />
      </div>
    );
  }, [status, onNeutral, onDownVote]);

  return (
    // TODO: don't add icons if "onReaction" is not defined?
    <MessageReactionsWrapper role={'row'}>
      <div className="message-reaction">
        <CopyButton textToCopy={textToCopy} onCopy={onCopy} />
      </div>
      {thumbsUpIcon}
      {thumbsDownIcon}
      {additionalActions}
    </MessageReactionsWrapper>
  );
};
